module.exports = __webpack_public_path__ + "img/DEFC.88a73e39.jpg";